import axios from 'axios';
import { getDomainName, objectToQueryString } from '~/utils/urlUtils';

export default class FacebookFlow {
    static async startAuthFlow(redirectPath, redirectQuery) {
        const clientId = process.env.VUE_APP_FACEBOOK_APP_ID;
        const state =
            getDomainName() +
            (redirectPath ? encodeURIComponent(redirectPath) : '/redirect') +
            (redirectQuery && !redirectPath
                ? objectToQueryString(redirectQuery)
                : '');
        const scope = 'email'; //'email,name,first_name,last_name,picture';
        const redirectUri = this.redirectUri();

        window.open(
            `https://www.facebook.com/v3.2/dialog/oauth?client_id=${clientId}&scope=${scope}&state=${state}&redirect_uri=${redirectUri}`,
            '_self'
        );
    }

    static async getAccessToken(authCode) {
        const state = getDomainName(); // Is necassary for storing which platform was used during registration
        return axios({
            method: 'GET',
            url: `${
                process.env.VUE_APP_IDENTITY_SERVER_URL
            }user/authenticate-facebook/?code=${authCode}&state=${state}`,
        });
    }

    static redirectUri() {
        return ''.concat(
            process.env.VUE_APP_IDENTITY_SERVER_URL,
            'user/authenticate-facebook/callback'
        );
    }
}
